// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3126":"e12e5b64d0675506","4877":"2ea0bf2021c7166f"}[chunkId] + ".js";
};